import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ConditionCardType,
  ConditionType
} from '../../../models/MessageType'
import {
  ConditionStatusIcon,
  ConditionStatusDoneIcon
} from '../../../icons/Icons'
import { generatePostBackObject } from '../../../actions/static'
import { keyType } from '../../../constants/string'

import {
  ConditionCardContainer,
  ConditionCardsWrapper,
  ConditionCardTitle,
  ConditionContainer,
  ConditionStatusIconContainer,
  ConditionName, ConditionButton
} from './ConditionCards.style'

interface Props {
  conditionCards: ConditionCardType[]
  postMessage: (m: any) => void
  isLastMessageInCurrentFlow: boolean
  isLoadingIframeData: boolean
}

const ConditionCards: React.FC<Props> = ({
  conditionCards,
  postMessage,
  isLastMessageInCurrentFlow,
  isLoadingIframeData
}) => {

  const conditionStatusIcon = (isPassed: boolean): JSX.Element => isPassed ? <ConditionStatusDoneIcon /> : <ConditionStatusIcon />
  const { t } = useTranslation()
  const clickHandler = (condition: ConditionType): void => {
    if (!isLastMessageInCurrentFlow || condition.passed || condition.disabled) return

    const message = {
      payload: condition.payload,
      title: condition.name
    }
    postMessage(generatePostBackObject(message))
  }

  const keyDownHandler = (e, condition: ConditionType) => {
    const key = e.key.toLowerCase()
    switch (key) {
      case keyType.ENTER:
      case keyType.SPACE:
        clickHandler(condition)
        break
    }
  }

  return (
    <ConditionCardsWrapper aria-label={t('condition_card')}>
      {conditionCards?.map((conditionCard, index) => (
        <ConditionCardContainer key={index}>
          {conditionCard.title &&
            <ConditionCardTitle>
              {conditionCard.title}
            </ConditionCardTitle>}
          <ul>
            {conditionCard.conditions.map((condition, index) => (
              <ConditionContainer
                key={index}
                data-test='condition-container'
              >
                <ConditionButton
                  isDisabled={condition.disabled}
                  isPassed={condition.passed}
                  isLastMessageInCurrentFlow={isLastMessageInCurrentFlow}
                  isLoadingIframeData={isLoadingIframeData}
                  onClick={() => clickHandler(condition)}
                  onKeyDown={(e) => keyDownHandler(e, condition)}
                >
                  <ConditionStatusIconContainer>
                    {conditionStatusIcon(condition.passed)}
                  </ConditionStatusIconContainer>
                  <ConditionName
                    isDisabled={condition.disabled}
                    isPassed={condition.passed}
                    isLastMessageInCurrentFlow={isLastMessageInCurrentFlow}
                  >
                    {condition.name}
                  </ConditionName>
                </ConditionButton>
              </ConditionContainer>
            ))}
          </ul>
        </ConditionCardContainer>
      ))}
    </ConditionCardsWrapper>
  )
}

export default ConditionCards
